import axios from "axios";
import loader from "../Assets/Img/globalLoader.gif";

export const baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_BACKEND_DEV_URL
    : process.env.REACT_APP_BACKEND_LOCAL_URL;

const token = localStorage.getItem("authToken");

const axiosMain = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Authorization: token ? `Bearer ${token}` : "",
  },
  withCredentials: true,
});

// Loader logic (unchanged)
let activeRequests = 0;

const createLoader = () => {
  document.body.style.overflow = "hidden";

  if (!document.getElementById("global-loader")) {
    const loaderDiv = document.createElement("div");
    loaderDiv.id = "global-loader";
    loaderDiv.style.position = "fixed";
    loaderDiv.style.top = "0";
    loaderDiv.style.left = "0";
    loaderDiv.style.width = "100vw";
    loaderDiv.style.height = "100vh";
    loaderDiv.style.background = "rgba(250, 246, 246, 0.56)";
    loaderDiv.style.display = "flex";
    loaderDiv.style.justifyContent = "center";
    loaderDiv.style.alignItems = "center";
    loaderDiv.style.zIndex = "9999";

    const img = document.createElement("img");
    img.src = loader;
    img.alt = "Loading...";
    img.style.width = "80px";
    img.style.height = "80px";

    loaderDiv.appendChild(img);
    document.body.appendChild(loaderDiv);
  }
};

const removeLoader = () => {
  setTimeout(() => {
    const loaderDiv = document.getElementById("global-loader");
    if (loaderDiv) {
      document.body.removeChild(loaderDiv);
    }
    document.body.style.overflow = "";
  }, 1000);
};

// ===== ✅ Duplicate Request Handling Setup =====
const pendingRequests = new Map();

const getRequestKey = (config) => {
  const { method, url, params, data } = config;
  return [method, url, JSON.stringify(params), JSON.stringify(data)].join("|");
};

// ===== Interceptors =====

axiosMain.interceptors.request.use(
  (config) => {
    // 🔁 Prevent Duplicate Requests
    const requestKey = getRequestKey(config);
    if (pendingRequests.has(requestKey)) {
      const cancel = pendingRequests.get(requestKey);
      cancel(); // cancel previous one
    }

    config.cancelToken = new axios.CancelToken((cancel) => {
      pendingRequests.set(requestKey, cancel);
      
    });

    // 🔄 Global Loader
    activeRequests++;
    if (activeRequests === 1) {
      createLoader();
    }

    return config;
  },
  (error) => {
    activeRequests--;
    if (activeRequests === 0) {
      removeLoader();
    }
    return Promise.reject(error);
  }
);

axiosMain.interceptors.response.use(
  (response) => {
    // ✅ Clean request key after success
    const requestKey = getRequestKey(response.config);
    pendingRequests.delete(requestKey);

    // 🔄 Global Loader
    activeRequests--;
    if (activeRequests === 0) {
      removeLoader();
    }

    return response;
  },
  (error) => {
    // ✅ Clean request key after failure or cancel
    const requestKey = getRequestKey(error.config || {});
    pendingRequests.delete(requestKey);

    // 🔄 Global Loader
    activeRequests--;
    if (activeRequests === 0) {
      removeLoader();
    }

    if (axios.isCancel(error)) {
      console.warn("Request canceled:", error.message);
    }

    return Promise.reject(error);
  }
);

export default axiosMain;
